import React from 'react';
import { useRoutes } from 'react-router-dom';
import router from './router/router';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { StylesProvider } from '@mui/styles';
import { themeCreator } from './core/theme/base';
import { persistor } from './store/configure-store';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';

const App = () => {
  const content = useRoutes(router);
  const curThemeName = localStorage.getItem('appTheme') || 'SnapAssessTheme';
  const theme = themeCreator(curThemeName);

  return (
    <PersistGate loading={null} persistor={persistor}>
      <ToastContainer />
      <StylesProvider injectFirst>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          {content}
        </ThemeProvider>
      </StylesProvider>
    </PersistGate>
  );
};

export default App;
